import { useEffect, useState } from 'react'
import { SESSION_STORAGE_KEY } from '../../utils'

interface IMenu {
  link_url: string
  name: string
  target: string
}

export const useMenu = () => {
  const [menuData, setMenuData] = useState<IMenu[]>([])
  const { REACT_APP_PLURALL_API_URL: apiUrl, REACT_APP_PLURALL_MENU_API_URL } = process.env

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const menu = sessionStorage?.getItem(SESSION_STORAGE_KEY)

        if (menu) {
          const { data } = JSON.parse(menu)

          setMenuData(data)

          return
        }

        const response = await fetch(`${REACT_APP_PLURALL_MENU_API_URL}?v=${new Date().getTime()}`)

        const data = await response.json()

        setMenuData(data?.menu?.items[0]?.sub_items || [])

        sessionStorage?.setItem(
          SESSION_STORAGE_KEY,
          JSON.stringify({
            data: data?.menu?.items[0]?.sub_items || [],
          }),
        )
      } catch (error) {
        console.warn(error)
      }
    }

    fetchMenu()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { menuData, scrollToTop, apiUrl }
}
